<template>
  <div>
    <table class="table">
      <thead>
        <tr>
          <th style="width: 11%">
            Tên khách hàng <span style="color: #ff0000">*</span>
          </th>
          <th style="width: 9%">
            SĐT / Mã bệnh nhân <span style="color: #ff0000">*</span>
            <i
              class="fas fa-info-circle text-muted"
              v-b-tooltip.hover.top="'Dùng Mã bệnh nhân với các trường hợp tài khoản không sử dụng số điện thoại (đăng nhập bằng Zalo/Google)'"
            ></i>
          </th>
          <th style="width: 7%">Giới tính<span style="color: #ff0000">*</span></th>
          <th style="width: 7%">Danh xưng</th>
          <th style="width: 7%">Nguồn</th>
          <th style="width: 6%">
            Năm sinh<span style="color: #ff0000">*</span>
          </th>
          <th style="width: 13%">
            Phân loại <span style="color: #ff0000">*</span>
          </th>
          <th style="width: 11%">
            Coach phụ trách<span style="color: #ff0000">*</span>
          </th>
          <th style="width: 15%">
            Gói dịch vụ<span style="color: #ff0000">*</span>
          </th>
          <th style="width: 9%">Nhóm Zalo</th>
          <th style="width: 5%"></th>
        </tr>
      </thead>
      <tbody>
        <customer-row
          v-for="(customer, index) in listCustomer"
          :key="index"
          :customerData="customer"
          :customerIndex="index"
        />
      </tbody>
    </table>

    <div class="d-flex justify-content-end align-items-center mt-4">
      <button class="btn btn-secondary" @click="addCustomer">
        <span class="svg-icon">
          <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
        </span>
        Thêm một khách hàng khác
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions } = createNamespacedHelpers('customerReceives');
export default {
  name: 'FormCreate',
  components: {
    'customer-row': () => import('./CustomerReceiveRow.vue'),
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['listCustomer']),
  },
  methods: {
    ...mapActions(['addCustomer']),
  },
};
</script>
<style lang="scss" scoped>
.table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

// .table th, .table td {

//   text-align: left;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   white-space: nowrap;
// }

.required {
  color: #ff0000;
}

.fa-info-circle {
  margin-left: 4px;
  cursor: help;
}
</style>
